export default __webpack_public_path__ + "static/media/device-cold.d84a7ea9.xlsx";